import ForgotPassword from "pages/auth/forgotPassword";
import Login from "pages/auth/login";
import Contact from "pages/dashboard/contact";
import RequestedEvaluations from "pages/dashboard/requestedEvaluations";
import DashboardHome from "pages/dashboard/home";
import { routeConstant } from "./routeConstant";
import ResetPassword from "pages/auth/resetPassword";
import Organizations from "pages/dashboard/organizations";
import ModifyQuestionnaire from "pages/dashboard/modifyQuestionnaire";
import EditQuestionnaire from "pages/dashboard/evaluation/[org]/edit/[id]";
import EvaluationDetail from "pages/dashboard/evaluation/[org]/[id]";
import OrganizationEvaluations from "pages/dashboard/organizations/[id]";
import AddOrganization from "pages/dashboard/organizations/add";
import EditOrganization from "pages/dashboard/organizations/edit/[id]";
import ContinueQuestionnaire from "pages/dashboard/completeEvaluation/[id]";
import OrganizationPendingEvaluations from "pages/dashboard/requestedEvaluations/[id]";
import Document from "pages/dashboard/document";

const publicRoute: any = [
  {
    path: routeConstant.login.path,
    title: routeConstant.login.title,
    Component: Login,
  },
  {
    path: routeConstant.forgotPassword.path,
    title: routeConstant.forgotPassword.title,
    Component: ForgotPassword,
  },
  {
    path: routeConstant.resetPassword.path,
    title: routeConstant.resetPassword.title,
    Component: ResetPassword,
  },
];

const privateRoute: any = [
  {
    path: routeConstant.dashboard.path,
    title: routeConstant.dashboard.title,
    Component: DashboardHome,
  },
  {
    path: routeConstant.organizations.path,
    title: routeConstant.organizations.title,
    Component: Organizations,
  },
  {
    path: routeConstant.requestedEvaluation.path,
    title: routeConstant.requestedEvaluation.title,
    Component: RequestedEvaluations,
  },
  {
    path: routeConstant.continuePendingEvaluation.path,
    title: routeConstant.continuePendingEvaluation.title,
    Component: ContinueQuestionnaire,
  },
  {
    path: routeConstant.singleOrganizationRequestedEvaluation.path,
    title: routeConstant.singleOrganizationRequestedEvaluation.title,
    Component: OrganizationPendingEvaluations,
  },
  {
    path: routeConstant.modifyQuestionnaire.path,
    title: routeConstant.modifyQuestionnaire.title,
    Component: ModifyQuestionnaire,
  },
  {
    path: routeConstant.contact.path,
    title: routeConstant.contact.title,
    Component: Contact,
  },
  {
    path: routeConstant.organizationDetail.path,
    title: routeConstant.organizationDetail.title,
    Component: OrganizationEvaluations,
  },
  {
    path: routeConstant.evaluationRecordDetail.path,
    title: routeConstant.evaluationRecordDetail.title,
    Component: EvaluationDetail,
  },
  {
    path: routeConstant.editEvaluationRecord.path,
    title: routeConstant.editEvaluationRecord.title,
    Component: EditQuestionnaire,
  },
  {
    path: routeConstant.addOrganization.path,
    title: routeConstant.addOrganization.title,
    Component: AddOrganization,
  },
  {
    path: routeConstant.editOrganization.path,
    title: routeConstant.editOrganization.title,
    Component: EditOrganization,
  },
  {
    path: routeConstant.document.path,
    title: routeConstant.document.title,
    Component: Document,
  },
];

export { privateRoute, publicRoute };
